import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
const styles = theme => ({
  settingsFormControl: {
    marginBottom: theme.spacing(3)
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -20,
  },
  previewContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  previewImage: {
    maxWidth: 600,
    maxHeight: 600,
    width: '100%',
    objectFit: 'scale-down',
    backgroundColor: 'lightgray',
  },
});
class PhotoSettingsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copies: props.copies || 1,
      imageLoaded: false,
      imageError: false,
    };
  }
  handleCopiesChanged = (event) => {
    const value = event.target.value;
    if (value === '' || (parseInt(value) > 0 && parseInt(value) <= 100)) {
      this.setState({ copies: value });
    }
  };
  handleCopiesBlur = () => {
    const copies = parseInt(this.state.copies) || 1;
    this.setState({ copies: Math.max(1, Math.min(100, copies)) });
    this.props.onSettingsChanged({ copies: Math.max(1, Math.min(100, copies)) });
  };
  increaseCopies = () => {
    const newCopies = Math.min(100, (parseInt(this.state.copies) || 1) + 1);
    this.setState({ copies: newCopies });
    this.props.onSettingsChanged({ copies: newCopies });
  };
  decreaseCopies = () => {
    const newCopies = Math.max(1, (parseInt(this.state.copies) || 1) - 1);
    this.setState({ copies: newCopies });
    this.props.onSettingsChanged({ copies: newCopies });
  };
  handleImageLoad = () => {
    this.setState({ imageLoaded: true, imageError: false });
  };
  handleImageError = () => {
    this.setState({ imageLoaded: false, imageError: true });
  };
  render() {
    const { classes, t, open, onClose, orderUrl, id } = this.props;
    const { copies, imageLoaded, imageError } = this.state;
    return (
      <Dialog
        onClose={onClose}
        open={open}
        scroll='body'
        maxWidth="md"
        fullWidth
        data-cy="photoSettingsDialog"
      >
        <DialogTitle>
          {t('photoSettings')}
        </DialogTitle>
        <DialogContent>
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div className={classes.previewContainer}>
              {!imageLoaded && !imageError && (
                <CircularProgress className={classes.progress} />
              )}
              {imageError && (
                <div style={{ textAlign: 'center', color: 'red' }}>
                  {t('errorLoadingPreview')}
                </div>
              )}
              <img
                src={orderUrl('/printjobs/' + id + '/preview/1')}
                className={classes.previewImage}
                onLoad={this.handleImageLoad}
                onError={this.handleImageError}
                alt="Photo preview"
                data-cy="photoSettingsDialog.preview"
                style={{ display: imageLoaded ? 'block' : 'none' }}
              />
            </div>
          </div>
          <FormControl fullWidth className={classes.settingsFormControl}>
            <InputLabel>{t('copies')}</InputLabel>
            <Input
              type="text"
              value={copies}
              onChange={this.handleCopiesChanged}
              onBlur={this.handleCopiesBlur}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    disabled={copies === 1}
                    onClick={this.decreaseCopies}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <IconButton
                    disabled={copies === 100}
                    onClick={this.increaseCopies}
                  >
                    <AddIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            variant="contained"
            autoFocus
            data-cy="photoSettingsDialog.okButton"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(withTranslation()(PhotoSettingsDialog));